import { apiUrl } from "../../../../Constant/apiConstant"
import { postFormRequest, postJsonRequest } from "../../../../service/apiService"

export const addOrUpdateUploadTracker=async(tenant:string|undefined,data:any)=>{
    try{
        const response=await postJsonRequest(apiUrl.JM_POST_ADD_OR_UPDATE_UPLOAD_TRACKER,data,tenant)
    }catch(error){
        console.log(error)
    }
}

export const  uploadResumesToOcr= async(tenant:string | undefined,files:File[],jobId:string)=>{
    try{
        const formData = new FormData();
        formData.append("jobId", jobId);
        files.forEach(file => formData.append("files", file));
        const response= await postFormRequest(apiUrl.JM_POST_UPLOAD_RESUMES_TO_OCR,formData,tenant,true)

        if(response.status === 200){
            return true
        }
    }catch(error){
        console.log(error)
    }
    return false
} 